import type { ToastProps } from '@iheartjane/reefer';
import { AlertIcon, CheckIcon } from '@iheartjane/reefer';
import { clsx } from 'clsx';
import { useCallback, useEffect, useState } from 'react';

import styles from './toast.module.css';

export function Toast({
  id,
  label,
  onClose,
  time = 2500,
  variant,
}: ToastProps) {
  const [isLeaving, setIsLeaving] = useState(false);

  const handleClose = useCallback(() => {
    setIsLeaving(true);
    setTimeout(() => onClose(id), 250);
  }, [id, onClose]);

  useEffect(() => {
    const timeout = setTimeout(() => handleClose(), time);

    return () => {
      clearTimeout(timeout);
    };
  }, [handleClose, time]);

  return (
    <div
      className={clsx(styles['animated'], { [styles['leaving']]: isLeaving })}
    >
      <div className={styles['container']}>
        {variant === 'success' && (
          <>
            <CheckIcon color="grays-white" mr={16} />{' '}
          </>
        )}
        {variant === 'error' && (
          <>
            <AlertIcon color="grays-white" mr={16} />{' '}
          </>
        )}
        {label}
      </div>
    </div>
  );
}
